import plusFill from '@iconify/icons-eva/close-circle-outline';
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';
// material
import { Button, Container, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';

//
// components
import { RunwaysForm } from '../components/AerosDetails';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { useTranslation } from '../common/LocalizationProvider';
import { selectAerosRunwaysArray } from '../createSelectorUtils';
// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '50vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function EditRunways() {
  const location = useLocation();
  const t = useTranslation();
  const navigate = useNavigate();

  const runway =
    useSelector(selectAerosRunwaysArray).find(
      (item) => item.id === (location.state !== null ? location.state.id : 0)
    ) || {};

  return (
    <Page title={t('ARE_Title')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            {t('edit_runway')}
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate(-1)}
            startIcon={<Icon icon={plusFill} />}
            color="secondary"
          >
            {t('btn_Cancel')}
          </Button>
        </Stack>
        <Scrollbar>
          <ContentStyle>
            <RunwaysForm
              runwayId={location.state !== null ? location.state.id : 0}
              runway={runway}
            />
          </ContentStyle>
        </Scrollbar>
      </Container>
    </Page>
  );
}
